export const COMMUNITY_PLUS_ENROLLMENT_MODAL = 'communityPlusEnrollment';

export const COMMUNITY_PLUS_DOCS_URL =
	'https://docs.n8n.io/hosting/community-edition-features/#registered-community-edition';
